import React from "react";
import { useContext } from "../../../context";

const convertDurationToVisibleFormat = (duration) => {
  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;
  return "(" + hours + " hrs " + minutes + " mins)";
};

export function Services() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>{appointment.packageId == 0 ? "Services" : "Packages"}:</label>
      <span>
        {appointment.packageId == 0 &&
          appointment.appointmentServices.map((s) => (
            <div className="services-listdiv service-list" key={s.id}>
              {s.name}
              <span data-duration_hours="0" className="duration_hours">
                {convertDurationToVisibleFormat(s.duration)}
              </span>
            </div>
          ))}
        {appointment.packageId != 0 && (
          <div className="services-listdiv service-list">
            {appointment.package?.name +
              " (" +
              appointment.package?.hours +
              " hrs " +
              appointment.package?.mins +
              "mins)"}
          </div>
        )}
      </span>
    </div>
  );
}
